import { render, staticRenderFns } from "./SpecificationForm.vue?vue&type=template&id=682e0870&scoped=true&"
import script from "./SpecificationForm.vue?vue&type=script&lang=js&"
export * from "./SpecificationForm.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/specification/SpecificationForm/SpecificationFormStyle.css?vue&type=style&index=0&id=682e0870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e0870",
  null
  
)

export default component.exports